import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {RelativeDateTimeFormatsEnum} from '../../../../../../srcCommon/formatters/dateTime/relativeDateTimeFormatter';
import {preventDragStart} from '../../../../../helpers/dragAndDropHelpers';
import {MessageModel, MessageVisualStatusesEnum} from '../../../../../models/api/messageModel';
import {InteractiveDateTimeFormatterContainer} from '../../../../common/formatters/dateTime/interactiveDateTimeFormatterContainer';

/*
 * Props.
 */

export interface MessageViewerDateProps {
  message: MessageModel;
  isInDragRegion?: boolean;
}

/*
 * Style.
 */

const StyledDateDiv = styled.div`
  color: ${(p) => p.theme.greys.shade60};
  line-height: 14px;
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.semibold};
  text-transform: uppercase;
  grid-area: date;
  margin: 0 7px;
`;

/*
 * Component.
 */

export const MessageViewerDate: FC<MessageViewerDateProps> = (props) => {
  const {message, isInDragRegion} = props;

  // We do not show the date if there is no date or if this is a shared draft.
  if (message.sentAt <= 0 || message.visualStatus === MessageVisualStatusesEnum.DRAFT) {
    return null;
  }

  return (
    <StyledDateDiv draggable={isInDragRegion} onDragStart={preventDragStart}>
      <InteractiveDateTimeFormatterContainer
        value={props.message.sentAt}
        relativeFormat={RelativeDateTimeFormatsEnum.LONG}
      />
    </StyledDateDiv>
  );
};
